// eslint-disable-next-line max-classes-per-file
import { AxiosResponse } from 'axios';
import { instance as axios } from '../../api/axios';
import { Role } from './interfaces';

class MyError extends Error {
  errorExtraParamsGet;

  constructor(message: any, errorExtraParams: any) {
    super(message);
    this.errorExtraParamsGet = errorExtraParams;
  }

  get errorExtraParams() {
    return this.errorExtraParamsGet;
  }
}

export class RolesService {
  public static async getRole() {
    try {
      const url = '/Roles';
      const response: AxiosResponse<Role> = await axios.get(url);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  public static async getRoles(id: number) {
    try {
      const url = '/Roles/all';
      const response: AxiosResponse<Role[]> = await axios.get(url, { params: { branchId: `${id}` } });
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
